import React, {useEffect, useState} from 'react';
import './service-block-with-button.scss'
import {Button} from "antd";
import {ServiceBlockWithButtonType} from "/react4xp/parts/service-block-with-button/service-block-with-button.type";
import {getImgUrl} from "/react4xp/parts/service-link-img/actions";

const ServiceBlockWithButton = (props: ServiceBlockWithButtonType) => {
    const [img, setImg] = useState({});

    useEffect(() => {
        if (props.config.image) {
            getImgUrl(props.config.image).then(
                value => {
                    if (value.data) {
                        setImg({background: `url(${value.data}) 0% 0% / cover no-repeat`});
                    }
                }
            );
        }
    }, []);

    const goTo = () => {
        window.location.href = '/' + props.language + props.config.url;
    };

    return (
        <div className="service-block-with-button">
            <div className="jycVCa" style={img}>
                    <span className="FyeUe">
                        {props.config.title}
                    </span>
                <span className="btIsje">
                        {props.config.desc}
                    </span>
                <Button type="primary" className="ant-btn hbbaBw eSZCWX" onClick={goTo}>
                    {props.config.buttonTitle}
                </Button>
            </div>
        </div>
    );
};

export default ServiceBlockWithButton;
